/**
 * @generated SignedSource<<84aeb4584109deafed6b201c1adccdde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetBookingWindowDaysByFacilityId$data = {
  readonly club: {
    readonly supportsPrivate: boolean;
  } | null | undefined;
  readonly id: string;
  readonly memberBookingWindowDays: number | null | undefined;
  readonly publicBookingWindowDays: number | null | undefined;
  readonly " $fragmentType": "useGetBookingWindowDaysByFacilityId";
};
export type useGetBookingWindowDaysByFacilityId$key = {
  readonly " $data"?: useGetBookingWindowDaysByFacilityId$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetBookingWindowDaysByFacilityId">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetBookingWindowDaysByFacilityId",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicBookingWindowDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberBookingWindowDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "supportsPrivate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "b4e8c7ed18ca3c57636522cdd76dcea4";

export default node;
